import { Grid, Typography } from '@mui/material'

import {
  COLOR_CX,
  COLOR_DRIVER_APP,
  COLOR_FULFILMENT_RATE,
  COLOR_TOTAL_JOBS,
  FULFILMENT_CX_INFO,
  FULFILMENT_DRIVER_APP_INFO,
  FULFILMENT_RATE_INFO,
  FULFILMENT_TOTAL_INFO,
} from 'components/reports/Metrics/constants/DriverAppFulfilment'
import { DriverAppFulfilmentSummaryDto } from 'generated/graphql'
import { formatRate } from 'helpers/fulfilmentTrendChart.helpers'

import { FulfilmentKpiCard } from './FulfilmentKpiCard'

interface Props {
  summary?: DriverAppFulfilmentSummaryDto | null
  loading?: boolean
}

const percentage = (value: unknown) => formatRate(Number(value ?? 0))

export const DriverAppFulfilmentSummary = ({ summary, loading }: Props) => {
  const unresolved = summary?.unresolvedJobs ?? 0

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <FulfilmentKpiCard
          title='Total jobs posted to Driver App'
          value={(summary?.totalJobsPosted ?? 0).toLocaleString()}
          caption='100% of total'
          color={COLOR_TOTAL_JOBS}
          info={FULFILMENT_TOTAL_INFO}
          loading={loading}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FulfilmentKpiCard
          title='Jobs fulfilled through Driver App'
          value={(summary?.driverAppFulfilledJobs ?? 0).toLocaleString()}
          caption={`${percentage(summary?.driverAppFulfilledPercentage)} of total`}
          color={COLOR_DRIVER_APP}
          info={FULFILMENT_DRIVER_APP_INFO}
          ringPercentage={Number(summary?.driverAppFulfilledPercentage ?? 0)}
          loading={loading}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FulfilmentKpiCard
          title='Jobs fulfilled through CX'
          value={(summary?.cxFulfilledJobs ?? 0).toLocaleString()}
          caption={`${percentage(summary?.cxFulfilledPercentage)} of total`}
          color={COLOR_CX}
          info={FULFILMENT_CX_INFO}
          ringPercentage={Number(summary?.cxFulfilledPercentage ?? 0)}
          loading={loading}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FulfilmentKpiCard
          title='Driver App fulfilment rate'
          value={percentage(summary?.driverAppFulfilmentRate)}
          caption='% of jobs fulfilled through Driver App'
          color={COLOR_FULFILMENT_RATE}
          info={FULFILMENT_RATE_INFO}
          loading={loading}
        />
      </Grid>

      {unresolved > 0 && (
        <Grid item xs={12}>
          <Typography variant='caption' color='text.secondary'>
            {unresolved.toLocaleString()} of the posted jobs have no outcome yet. They count towards
            the total but are left out of the fulfilment rate.
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}
